import React from "react";
import { Box, SxProps } from "@mui/material";
import { ReactNode, useContext } from "react";
import { useDraggable } from '@dnd-kit/core';
import { makeBoxStyles } from "system/query/QueryUtility";
import { BuilderContext } from "components/queries/QueryBuilderPanel";
import { Theme } from "@emotion/react";

export interface QueryBuilderBoxProps {
  label?: string;
  path?: string;
  draggable?: boolean;
  borderColor: string;
  borderColorTop: string;
  isAddingActive?: boolean;
  backgroundColor: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  children?: ReactNode;
}

export function QueryBuilderBox(props: QueryBuilderBoxProps): JSX.Element {
  const {draggingIsDisabled} = useContext(BuilderContext);

  const {isDragging, attributes, listeners, setNodeRef, transform} = useDraggable({
    id: props.path || '.',
    disabled: !props.draggable || draggingIsDisabled
  });

  const sxProps:SxProps<Theme> = makeBoxStyles(props.backgroundColor, props.borderColor, props.borderColorTop,
    false, transform, props.isAddingActive, isDragging);
  return (
    <Box sx={{...sxProps, width: 'max-content', minWidth: '330px', maxWidth: '100%', position: 'relative'}}
      {...listeners}
      {...attributes}
      ref={setNodeRef}
      onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (props.onClick) {
          event.stopPropagation();
          props.onClick(event);
        }
      }}
      >
      <Box>
      {props.children}
      </Box>
    </Box>
  );
}